import {
  IConfigBridgeFileData,
  ICreateDefenseBridgeProps,
  IDefenseBridgeProps,
  IUpdateDefenseBridgeParams,
} from './types';
import { api } from '../../DefaultService';

const ENDPOINT = '/v1/defense/bridge';

export const createDefenseBridgeAsync = async (
  data: ICreateDefenseBridgeProps,
): Promise<IDefenseBridgeProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateDefenseBridgeAsync = async ({
  data,
  id,
}: IUpdateDefenseBridgeParams): Promise<IDefenseBridgeProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteDefenseBridgeAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getDefenseBridgeAsync = async (
  id: number,
): Promise<IDefenseBridgeProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getDefenseBridgeByLicenseAsync =
  async (): Promise<IDefenseBridgeProps> => {
    return await api
      .get(`${ENDPOINT}/getByLicense`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  };

export const downloadEventTypesExcelFileAsync =
  async (): Promise<IConfigBridgeFileData> => {
    return await api
      .get(`${ENDPOINT}/files/excel/eventTypes`, {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/zip',
        },
      })
      .then((response) => {
        return { data: response.data, fileName: 'AlertAiEventType.zip' };
      })
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  };

export const downloadSourceEventTypesExcelFileAsync =
  async (): Promise<IConfigBridgeFileData> => {
    return await api
      .get(`${ENDPOINT}/files/excel/sourceEventTypes`, {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/zip',
        },
      })
      .then((response) => {
        return { data: response.data, fileName: 'AlertAiSourceEventType.zip' };
      })
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  };
